<template>
	<div class="modal-card ops_by_users_card">
		<header class="modal-card-head has-background-white">
			<h3 class="modal-card-title has-text-centered">
				<span>
					Operaciones actuales del usuario seleccionado
				</span>
			</h3>
			<button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
		</header>
		<section class="modal-card-body ops_body">
			<div class="users_nav" role="navigation" aria-label="main navigation">
				<div class="users_pills">
					<a class="user_pill" :class="{
						'is-selected': selectedUser && selectedUser.user_id == user.user_id
					}" @click="() => selectUser(user)" v-for="user in allUsers" v-bind:key="user.user_id">
						{{ user.user_email }}
					</a>
				</div>
			</div>
			<div class="blurry" id="data_div">
				<div class="columns is-multiline">
					<div class="column is-12">
						<InputWithValidation id="urlLooker" name="urlLooker" label="Url Looker:" v-model="urlLooker"
							rules="required" />
					</div>
					<div class="column is-4">
						<label class="checkbox">
							<input type="checkbox" v-model="isActive" />
							Puede ingresar a la plataforma
						</label>
					</div>
					<div class="column is-4">
						<label class="checkbox">
							<input type="checkbox" v-model="noHasSIIMsg" />
							No mostrar mensaje de conectar el SII
						</label>
					</div>
					<div class="column is-4">
						<label class="checkbox">
							<input type="checkbox" v-model="hasConciliator" />
							Tiene conciliador
						</label>
					</div>
					<div class="column is-4">
						<label class="checkbox">
							<input type="checkbox" v-model="hasReport" />
							Tiene reporte looker
						</label>
					</div>
					<div class="column is-4">
						<label class="checkbox">
							<input type="checkbox" v-model="hasClassification" />
							Tiene clasificador
						</label>
					</div>
					<div class="column is-4">
						<label class="checkbox">
							<input type="checkbox" v-model="hasFinancialReport" />
							Tiene reporte en linea
						</label>
					</div>
					<div class="column is-4">
						<label class="checkbox">
							<input type="checkbox" v-model="hasFinanciamiento" />
							Tiene Financiamiento
						</label>
					</div>
				</div>
				<div class="container" v-if="selectedUser">
					<strong>Tipos de contraparte que el usuario puede ver:</strong>
					<div class="options-grid">
						<div v-for="counterpart in typeOptions" :key="counterpart.value">
							<div class="is-flex is-flex-grow-2 is-flex-shrink-4">
								<label class="checkbox">
									<input type="checkbox" v-model="counterpart.active"/>
									{{ counterpart.label }}
								</label>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<table class="table is-narrow">
						<tbody>
							<tr>
								<td style="font-weight: 900;">-------------------</td>
							</tr>
							<tr>
								<td>-------------------</td>
							</tr>
							<tr>
								<td>-------------------</td>
							</tr>
							<tr>
								<td>-------------------</td>
							</tr>
							<tr>
								<td>-------------------</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>
		<footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
			<button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
				Volver
			</button>
			<button class="button is-primary" :disabled="loading || selectedUser == null" role="button"
				@click="updateUserOperations()">
				Grabar
			</button>
		</footer>
	</div>
</template>

<script>
import { getUsersByCompany, updateUserOperations } from "@/api/carteraAnalista";
import InputWithValidation from "@/components/inputs/InputWithValidation";
export default {
	name: "ChangeOperationsByUsers",
	data() {
		return {
			loading: false,
			selectedUser: null,
			urlLooker: "",
			hasConciliator: false,
			hasClassification: false,
			hasFinancialReport: false,
			hasReport: false,
			noHasSIIMsg: false,
			isActive: false,
			canUploadFiles: false,
			hasFinanciamiento: false,
			allUsers: [],
			typeOptions: []
		};
	},
	components: {
		InputWithValidation
	},
	methods: {
		selectUser(user) {
			this.selectedUser = user
			this.urlLooker = user.url_report
			this.hasConciliator = user.has_conciliator
			this.hasClassification = user.has_classificator
			this.hasFinancialReport = user.has_financial_report
			this.hasReport = user.has_embedded_report
			this.hasFinanciamiento = user.has_financiamiento
			this.noHasSIIMsg = user.no_sii_message
			this.isActive = user.is_active
			this.canUploadFiles = user.has_file_upload

			const userValidCounterparts = [...(this.selectedUser.user_valid_counterparts || [])]
			// Lista vacía = el usuario ve TODOS los tipos (misma semántica que
			// classification.js / DashboardClassificator) — se refleja con
			// todas las alternativas marcadas, no desmarcadas.
			const seesAll = userValidCounterparts.length === 0
			this.typeOptions = this.typeOptions.map(type => {
				return {
					...type,
					active: seesAll || userValidCounterparts.includes(type.value)
				};
			});
			const myDiv = document.getElementById("data_div");
			if (myDiv) {
				myDiv.classList.remove("blurry");
			}
		},
		updateUserOperations() {
			const reqUserOps = {
				user_id: this.selectedUser.user_id,
				url_report: this.urlLooker,
				has_conciliator: this.hasConciliator,
				has_classificator: this.hasClassification,
				has_financial_report: this.hasFinancialReport,
				has_embedded_report: this.hasReport,
				no_sii_message: this.noHasSIIMsg,
				is_active: this.isActive,
				has_file_upload: this.canUploadFiles,
				has_financiamiento: this.hasFinanciamiento,
			}
			let counterpartTypes = []
			this.typeOptions.map(type=>{
				if(type.active){
					counterpartTypes.push(type.value)
				}
			})
			reqUserOps.counterpart_types = counterpartTypes
			updateUserOperations(this.idCompany, reqUserOps).then(() => {
			}).finally(() => {
				this.$emit("close");
			})
		}
	},
	props: ["idCompany"],
	created() {
		getUsersByCompany(this.idCompany).then(({ data }) => {
			this.allUsers = data
		})
		this.typeOptions = [
			{ value: "Cliente", label: "🤝 Cliente", active: false },
			{ value: "Proveedor", label: "💼 Proveedor", active: false },
			{ value: "Honorario", label: "🕒 Honorario", active: false },
			{ value: 'Trabajador', label: '🧑‍💻 Trabajador', active: false },
			{ value: 'Internacional', label: '🌍 Internacional', active: false },
			{ value: 'Recibo', label: '🧾 Recibo', active: false },
			{ value: 'Finiquito', label: '📄 Finiquito', active: false },
		];
	},
};
</script>
<style scoped lang="scss">
// Tema del analista (var(--ap-*), elements/_analyst_theme.scss).
.ops_by_users_card {
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
	width: min(760px, 94vw);
	display: flex;
	flex-direction: column;
	max-height: 86vh;
	background-color: var(--ap-paper);
	border-radius: var(--ap-radius);
	overflow: hidden;
}

:deep(.modal-card-title){
	font-family: var(--ap-font);
	font-weight: 700;
	font-size: 20px;
	letter-spacing: -0.01em;
	color: var(--ap-ink);
}

.modal-card-head {
	border-bottom: 1px solid var(--ap-line);
}

.ops_body {
	background-color: var(--ap-paper);
	color: var(--ap-ink-2);
}

.users_nav {
	background-color: var(--ap-paper);
}

// Píldoras de selección de usuario.
.users_pills {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 4px;
}

.user_pill {
	display: inline-flex;
	align-items: center;
	padding: 7px 14px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-pill);
	background-color: var(--ap-mist);
	color: var(--ap-slate);
	font-family: var(--ap-font);
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.14s var(--ap-ease),
		color 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease);

	&:hover {
		border-color: var(--ap-teal);
		color: var(--ap-teal-deep);
	}

	&.is-selected {
		background-color: var(--ap-ink);
		border-color: transparent;
		color: var(--ap-paper);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

// Chrome del input (Buefy .input dentro de InputWithValidation compartido).
:deep(.input){
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	color: var(--ap-ink);
	box-shadow: none;
	transition: border-color 0.14s var(--ap-ease), box-shadow 0.14s var(--ap-ease);

	&:focus,
	&:focus-visible {
		border-color: var(--ap-teal);
		box-shadow: 0 0 0 3px var(--ap-teal-wash);
	}
}

:deep(.label){
	color: var(--ap-slate);
	font-weight: 600;
	font-size: 13px;
}

.blurry {
	margin-top: 30px;
	filter: blur(15px);
	background-color: var(--ap-mist);
}

#data_div {
	margin-top: 24px;
}

.container strong {
	color: var(--ap-ink);
	font-weight: 700;
}

.checkbox {
	color: var(--ap-ink-2);
	font-size: 13.5px;

	input[type="checkbox"] {
		accent-color: var(--ap-teal);
		margin-right: 6px;
	}
}

.options-grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 15px;
	margin-top: 10px;
}

:deep(.modal-card-foot){
	border-top: 1px solid var(--ap-line);

	.button.is-primary {
		background-color: var(--ap-ink);
		border-color: transparent;
		font-weight: 600;

		&:hover {
			background-color: var(--ap-teal-deep);
		}

		&:focus-visible {
			outline: 2px solid var(--ap-teal);
			outline-offset: 2px;
		}
	}
}
</style>